export const testIdAddDealButton = 'test-id_add-deal-button';
export const testIdShiftDealLeftButton = 'shift-deal-left-button';
export const testIdShiftDealRightButton = 'shift-deal-right-button';
export const testIdRemoveDealButton = 'remove-deal-button';
